<template>
  <div>
    <div
      v-for="(
        {
          id,
          name,
          asset,
          metric_expanded,
          is_approver,
          is_owner,
          owners,
          data_approvers,
          data_collection_frequency,
          data_aggregation_type,
          last_updated_by,
          updated_at,
        },
        mIndex
      ) in topicMetrics"
      :key="`asset-${id}-${asset.id}-${mIndex}`"
      class="flex items-center justify-between w-full px-4 py-3 mb-2 bg-white border rounded-md border-slate-200"
    >
      <div class="w-full">
        <div class="flex items-center justify-between w-full gap-x-3">
          <div class="flex items-center w-full gap-x-5">
            <h3 class="text-sm font-medium text-[#101828]">
              {{ name }}
            </h3>
            <div class="whitespace-nowrap rounded-md bg-[#2185791A] px-4 py-1.5 text-sm font-medium text-[#218579]">
              {{ asset ? asset.name : null }}
            </div>
          </div>

          <div class="flex items-center gap-x-3">
            <div class="relative flex flex-nowrap items-center gap-x-3 text-xs text-[#68737D]">
              <button
                class="whitespace-nowrap rounded-full bg-[#ED8F1C] px-4 py-2.5 text-white"
                @click="$emit('showInformationGuide', topicMetrics[mIndex])"
              >
                View Guidance
              </button>
              <NuxtLink
                v-if="is_owner"
                :to="`/dashboard/data-entry/esg-data-entry/${id}?asset=${encodedId(asset.id)}`"
                class="bg- whitespace-nowrap rounded-full bg-[#204B6F] px-4 py-2.5 text-white"
              >Enter Data</NuxtLink>
              <NuxtLink
                v-if="is_approver"
                :to="`/dashboard/data-entry/esg-data-entry/approval/${id}?asset=${encodedId(asset.id)}`"
                class="whitespace-nowrap rounded-full bg-[#218579] px-4 py-2.5 text-white disabled:bg-[#C7E1DD]"
              >Approve
                Data</NuxtLink>
              <button
                type="button"
                :title="metric_expanded ? 'Hide' : 'Expand'"
                class="py-3 pr-4 text-gray-500 bg-transparent rounded font-inter"
                @click="toggleMetricTemplates(mIndex)"
              >
                <ChevronDownLarge :custom-style="`h-5 w-5 ${metric_expanded ? 'rotate-180' : ''}`" />
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="metric_expanded"
          :key="`expanded-${id}`"
          class="flex items-start w-full p-4 mt-3 text-sm border-t-2 gap-x-6"
        >
          <div class="flex flex-col gap-0.5 font-medium">
            <span class="font-semibold text-primary">Approvers</span>
            <span class="no-localize-translate text-secondary">{{
              data_approvers ? data_approvers : "-"
            }}</span>
          </div>
          <div class="flex flex-col gap-0.5 font-medium">
            <span class="font-semibold text-primary">Data Owners</span>
            <span class="capitalize no-localize-translate text-secondary">{{
              owners ? owners : "-"
            }}</span>
          </div>
          <div class="flex flex-col gap-0.5 font-medium">
            <span class="font-semibold text-primary">Frequency</span>
            <span class="capitalize text-secondary">{{
              data_collection_frequency
            }}</span>
          </div>
          <div class="flex flex-col gap-0.5 font-medium">
            <span class="font-semibold text-primary">Data Aggregation Type</span>
            <span class="capitalize text-secondary">{{
              data_aggregation_type
            }}</span>
          </div>
          <div class="flex flex-col gap-0.5 font-medium">
            <span class="font-semibold text-primary">Last Updated</span>
            <span
              v-if="last_updated_by"
              class="no-localize-translate text-secondary"
            >{{
              $moment(updated_at).format("DD/MM/YYYY HH:mm:ss") }} by
              <span class="capitalize">{{ last_updated_by.first_name || "" }}
                {{ last_updated_by.last_name || "" }}</span></span>
            <span
              v-else
              class="text-secondary"
            >-</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EsgDataUploadMetricsAccordion',

  props: {
    metrics: {
      type: Array,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
  },

  emits: ['showInformationGuide'],

  data() {
    return {
      isOpen: false,
      topicMetrics: this.transformTopicMetrics(this.metrics),
    }
  },

  watch: {
    metrics(newMetrics) {
      this.topicMetrics = this.transformTopicMetrics(newMetrics)
    },
  },

  methods: {
    transformTopicMetrics(metrics) {
      if (!metrics.length) {
        return []
      }
      return metrics.map((metric) => {
        metric.is_owner = metric.data_owners.some(
          owner => owner.id === this.userData.id,
        )
        metric.is_approver = metric.approvers.some(
          owner => owner.id === this.userData.id,
        )
        metric.owners = metric.data_owners
          ?.map(owner => `${owner.first_name} ${owner.last_name}`)
          .join(', ')
        metric.data_approvers = metric.approvers
          ?.map(approver => `${approver.first_name} ${approver.last_name}`)
          .join(', ')
        metric.metric_expanded = false
        return metric
      })
    },
    toggleMetricTemplates(index) {
      this.topicMetrics[index].metric_expanded
        = !this.topicMetrics[index].metric_expanded
      getCurrentInstance()?.proxy?.$forceUpdate()
    },
    encodedId(id) {
      return this.$buffer.from(id.toString(), 'utf-8').toString('base64')
    },
  },
}
</script>
